import React, { useEffect } from 'react';
import CustomTab from './../../../../../components/CustomTab';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import { privilegesPlatforms, TAB_OPTIONS } from '../Model/AllowedModules';
import MobileRoles from './MobileRoles';
import WebsiteRoles from './WebsiteRoles';
import SetUpPrivilegesApp from '../Functionality/SetUpPrivilegesApp';
import CustomCard from './../../../../../components/CustomCard';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { FormHelperText } from '@mui/material';
import { CustomStyleFormHelperText } from '../../../../../components/Styles';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const SetUpPrivileges = (props) => {
    const {
        roleListData,
        mobile,
        web,
        roleName,
        emptyFields,
        selectedPermissions,
        setSelectedPermissions,
        clearField,
        id,
        readOnly,
        item,
        handleChange,
        emptyPrivilege
    } = props;
    const { selectedInnerView, handleStepSelectedInnerView, t, totalSelected } = SetUpPrivilegesApp({
        mobile,
        web,
        selectedPermissions,
    });

    return (
        <>
            <div className='mt-3 pt-3'>
                <div className={'ml-1'}>
                    {!id && (
                        <div className='col-12 d-flex justify-content-end mb-2 px-0'>
                            <ButtonIcon
                                id='btn_sup_clean_fields'
                                Icon={CleanIcon}
                                onClick={clearField}
                                title={'clear_instances'}
                                className={'btn-clean-secondary-600'}
                                tooltipPlacement={'right'}
                                iconProps='btn-icon-svg-12px icon-color-general-00'
                            />
                        </div>
                    )}
                </div>
                <div className={'col-12 px-0 mt-3 pt-3 '}>
                    <CustomTextField
                        id={'txt_sup_name'}
                        length={128}
                        name={'roleName'}
                        trans={'name'}
                        type={'text'}
                        required={true}
                        value={item?.roleName}
                        emptyFields={emptyFields}
                        onChange={handleChange}
                        disabled={readOnly}
                    />
                </div>
                <p className='ibl-font-w-600 font-color-text-950 fs-14px mb-4'>{t('assign_privileges')}</p>

                <CustomCard
                    classes={`w-100 h-100 border-radius-8px ${
                        emptyPrivilege ? 'border-full-error-code-600' : 'border-full-shades-100'
                    }`}
                >
                    <div className='d-flex align-items-center'>
                        <CustomTabContainer
                            activeTab={selectedInnerView}
                            setActiveTab={handleStepSelectedInnerView}
                            className='rounded-top border-0 px-3'
                        >
                            {privilegesPlatforms.map((platform) => {
                                const selectedCount = (selectedPermissions || []).filter((permission) => {
                                    const permissionData =
                                        platform.id === TAB_OPTIONS.MOBILE
                                            ? mobile?.find((item) => item.id === permission.id)
                                            : web?.find((item) => item.id === permission.id);

                                    return !!permissionData;
                                }).length;

                                return (
                                    <CustomTab
                                        key={platform.id}
                                        id={platform.id}
                                        title={t(platform.translation)}
                                        icon={platform.icon}
                                        newsNumber={selectedCount}
                                        selected={selectedInnerView === platform.id}
                                        onClick={() => handleStepSelectedInnerView(platform.id)}
                                    />
                                );
                            })}
                        </CustomTabContainer>

                        <div className='vertical-separator-shades-950 h-36px align-self-center' />

                        <div className='d-flex align-items-center gap-2 custom-tab-container pl-2'>
                            <span className='ibl-font-w-500 font-color-text-950 fs-16px mb-0'>
                                {t('total_selected')}
                            </span>

                            <div className='custom-tab-news-number d-flex px-1 justify-content-center align-items-center border-radius-8px cursor-pointer minw-18px h-fit'>
                                {totalSelected}
                            </div>
                        </div>
                    </div>
                    <div className={'border-bottom-shades-300'} />
                    {selectedInnerView === TAB_OPTIONS.MOBILE && (
                        <MobileRoles
                            mobile={mobile}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                            readOnly={readOnly}
                        />
                    )}

                    {selectedInnerView === TAB_OPTIONS.WEB && (
                        <WebsiteRoles
                            t={t}
                            web={web}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                            readOnly={readOnly}
                        />
                    )}
                </CustomCard>

                <div className={'col-12 px-0 mx-0 mt-1'}>
                    <FormHelperText error={true} sx={CustomStyleFormHelperText(false)}>
                        {emptyPrivilege && t('requiredField')}
                    </FormHelperText>
                </div>
            </div>
        </>
    );
};

export default SetUpPrivileges;
